export enum GameStatus {
  'IDLE' = 'IDLE',
  'WIN' = 'WIN',
  'ONGOING' = 'ONGOING',
  'LOST' = 'LOST',
}
